import { produce } from 'immer'
import {
  GET_NOTIFICATIONS_COUNT_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  GET_NOTIFICATIONS_INIT,
  GET_NOTIFICATIONS_SUCCESS,
  GetNotificationsActions,
  GetNotificationsCountActions,
  POST_NOTIFICATION_SUCCESS,
  POST_READ_ALL_NOTIFICATIONS_SUCCESS,
  PostNotificationActions,
  PostReadAllNotificationsActions,
} from 'src/app/Notifications/redux/notifications.actions'
import {
  NotificationListResponse,
  NotificationStatus,
} from 'src/models/notifications.models'
import { PaginationResponse } from 'src/models/pagination.models'

export interface NotificationsState {
  listResponses: Record<string, NotificationListResponse>
  loading: boolean
  complete: boolean
  unreadCount: number
  pagination?: PaginationResponse
}

export const initialState: NotificationsState = {
  listResponses: {},
  loading: false,
  complete: false,
  unreadCount: 0,
}

export type Actions =
  | GetNotificationsActions
  | GetNotificationsCountActions
  | PostReadAllNotificationsActions
  | PostNotificationActions

// Notification data will only be called when page is refreshed or on first load. Thus we'll keep all the notification data in the app state and skip adding it to the data state.
const NotificationsReducer = (
  state: NotificationsState = initialState,
  action: Actions,
): NotificationsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_NOTIFICATIONS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_NOTIFICATIONS_SUCCESS: {
        draft.loading = false
        draft.listResponses =
          action.payload.pagination.page === 0
            ? action.payload.notifications.reduce(
                (acc, curr) => ({
                  ...acc,
                  [curr.id]: curr,
                }),
                {},
              )
            : action.payload.notifications.reduce(
                (acc, curr) => ({
                  ...acc,
                  [curr.id]: curr,
                }),
                draft.listResponses,
              )
        draft.pagination = action.payload.pagination
        draft.complete =
          action.payload.pagination.page >=
          action.payload.pagination.numberOfPages
        return draft
      }

      case GET_NOTIFICATIONS_FAILURE: {
        /*
        If we get back a failure, just give up.
        In the future, we may wish to show a specific error message.
        */
        draft.loading = false
        draft.complete = true
        return draft
      }

      case GET_NOTIFICATIONS_COUNT_SUCCESS: {
        draft.unreadCount = action.payload.count
        return draft
      }

      case POST_READ_ALL_NOTIFICATIONS_SUCCESS: {
        draft.listResponses = Object.values(draft.listResponses).reduce(
          (acc, notification) => ({
            ...acc,
            [notification.id]: {
              ...notification,
              status: NotificationStatus.read,
            },
          }),
          draft.listResponses,
        )
        draft.unreadCount = 0
        return draft
      }

      case POST_NOTIFICATION_SUCCESS: {
        draft.listResponses = {
          ...draft.listResponses,
          [action.payload.notificationId]: {
            ...draft.listResponses[action.payload.notificationId],
            status: NotificationStatus.read,
          },
        }
        draft.unreadCount--
        return draft
      }
    }
  })
}

export default NotificationsReducer
